import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {injectIntl, intlShape, defineMessages} from 'react-intl';
import VM from 'scratch-vm';

import spriteLibraryContent from '../lib/libraries/sprites.json';
import randomizeSpritePosition from '../lib/randomize-sprite-position';
import spriteTags from '../lib/libraries/sprite-tags';

import LibraryComponent from '../components/library/selflibrary.jsx';

const messages = defineMessages({
    libraryTitle: {
        defaultMessage: 'Choose a Sprite',
        description: 'Heading for the sprite library',
        id: 'gui.spriteLibrary.chooseASprite'
    }
});

class SpriteLibrary extends React.PureComponent {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleItemSelect'
        ]);
		
/*      this.state = {
			totalData:spriteLibraryContent
        }; */
    }
	
    componentDidMount () {
        // Allow the spinner to display before loading the content
/* 		fetch('/portal/scratch/sprites.html', {
			method: "GET",
			headers: {
			'Content-Type': 'application/json',
			'Accept': 'application/json'
			}
		}).then(response => response.json())//解析为Promise
		  .then(data => {
			  
				this.setState({totalData: data})  ////赋值到本地数据
		}); */
		
	}
  
  
    handleItemSelect (item) {
        // Randomize position of library sprite
        randomizeSpritePosition(item);
        this.props.vm.addSprite(JSON.stringify(item.json)).then(() => {
            this.props.onActivateBlocksTab();
        });
    }
	
    render () {
        return (
            <LibraryComponent
                data={spriteLibraryContent}
                //data={this.state.totalData}
                dataurl='/portal/Material/sprites.html'
				libraryname="角色库"
                id="spriteLibrary"
                tags={spriteTags}
                title={this.props.intl.formatMessage(messages.libraryTitle)}
                onItemSelected={this.handleItemSelect}
                onRequestClose={this.props.onRequestClose}
            />
        );
    }
}

SpriteLibrary.propTypes = {
    intl: intlShape.isRequired,
    onActivateBlocksTab: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func,
    vm: PropTypes.instanceOf(VM).isRequired
};

export default injectIntl(SpriteLibrary);
